import React from 'react';
import ReactDOM from 'react-dom/client';
import { SupplierAutoLab } from '@dvvb/supplier-auto-ui';
import { useMemo, useState } from 'react';
import {
  createSosSupplierAutoPersistenceAdapter,
  loginToSosApi,
  readStoredSupplierAutoToken,
  writeStoredSupplierAutoToken,
} from './sos-api';
import './styles.css';

const API_BASE = import.meta.env.VITE_API_BASE ?? 'https://api.dvvb.io';

function SupplierAutoDemoApp() {
  const [token, setToken] = useState(() => readStoredSupplierAutoToken());
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [authMessage, setAuthMessage] = useState(token ? 'SOS API 연결됨' : 'mock 상태');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const persistenceAdapter = useMemo(() => (
    token
      ? createSosSupplierAutoPersistenceAdapter({
        baseUrl: API_BASE,
        getToken: () => token,
      })
      : undefined
  ), [token]);

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoggingIn(true);
    setAuthMessage('로그인 확인 중');
    try {
      const result = await loginToSosApi(API_BASE, email, password);
      writeStoredSupplierAutoToken(result.userSessionToken);
      setToken(result.userSessionToken);
      setPassword('');
      setAuthMessage(`${result.organizations[0]?.name ?? result.user.email} API 연결됨`);
    } catch (error) {
      setAuthMessage(error instanceof Error ? error.message : '로그인 실패');
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleLogout = () => {
    writeStoredSupplierAutoToken(null);
    setToken(null);
    setAuthMessage('mock 상태');
  };

  return (
    <>
      <div className={`supplier-auto-api-bar ${token ? 'is-connected' : ''}`} aria-label="SOS API 연결">
        <strong>{authMessage}</strong>
        {token ? (
          <button type="button" onClick={handleLogout}>연결 해제</button>
        ) : (
          <form onSubmit={(event) => void handleLogin(event)}>
            <input
              type="email"
              autoComplete="username"
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <input
              type="password"
              autoComplete="current-password"
              placeholder="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <button type="submit" disabled={isLoggingIn || !email || !password}>
              API 연결
            </button>
          </form>
        )}
      </div>
      <SupplierAutoLab key={token ?? 'mock'} persistenceAdapter={persistenceAdapter} />
    </>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <SupplierAutoDemoApp />
  </React.StrictMode>,
);
